import React from "react";

const sectionComplete = 'Section Complete!';
const sectionIncomplete = 'Section Incomplete';

// Section status header primarily for ApplicationForm
// Takes in boolean 'complete'
export default function SectionStatusHeader(props) {
    return <h2 className={props.complete ? "completed section-status header" 
        : "incomplete section-status header"}>{props.complete ? sectionComplete : sectionIncomplete}</h2>
};